import {
  IControl,
  IFormDocument,
} from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { ISPFieldType } from '../model';

interface MixedPlaceholderOptions {
  /** Control metadata */
  control: IControl;
  /** Is control in mixed */
  isMixed: boolean;
  /** Control type */
  type: ISPFieldType;
}

/**
 * Get local message for placeholder
 *
 * @param doc
 * @param params
 */
export function getControlPlaceholder(
  doc: IFormDocument,
  params: MixedPlaceholderOptions,
): string {
  if (params.isMixed) {
    return DocHelper.getMessage('placeholder_mixed_msg', doc);
  }

  switch (params.type) {
    case ISPFieldType.Select:
      return (
        DocHelper.getMessage(`${params.control.$name}_nullmsg`, doc) ||
        DocHelper.getMessage('null', doc)
      );
    case ISPFieldType.TextEditor:
      return '';
    case ISPFieldType.DatePicker:
      // @WARN do not use BE placeholder! They have legacy placeholders with wrong mask
      return '';
    default:
      return DocHelper.getMessage(`placeholder_${params.control.$name}`, doc);
  }
}
